
export const HcpFormat = new Intl.NumberFormat('de', { maximumFractionDigits: 2 });
